export default class YearBuilder {
    constructor(sheet) {
        this.sheet  = sheet;
        this.scroll = sheet.scroll;
        this.config = sheet.config;
        this.input  = sheet.input;
        this.main   = sheet.main;
        this.root   = sheet.root;
    }

    build(year) {
        return _createYearEl.call(this, year);
    }
}

function _createYearEl(year) {
    const months = _getMonths.call(this, year);

    let yearStr = `<div class="f-calendar__sheet--year" year="${ year }">`;

    // Проходим по списку месяцев и строим для каждого свой элемент
    months.forEach((monthTitle, month) => {
        if (!monthTitle.length) {
            return;
        }

        const buildDays = (weekData) => {
            let daysStr = '';

            weekData.forEach(({ date, day, disabled, month, stub, year }) => {
                let classList = 'f-calendar__sheet--day';

                if (disabled) {
                    classList += ' f-calendar__sheet--day_disabled';
                }

                if (stub) {
                    classList += ' f-calendar__sheet--day_stub';
                }

                // TODO active тоже нужен по хорошему

                /* eslint indent:0 */
                const dayStr = [
                    '<div',
                        `class="${ classList }"`,
                        `date="${ date || '' }"`,
                        `month="${ month }"`,
                        `year="${ year || '' }"`,
                        `day="${ day || '' }"`,
                    '>',
                        !stub && date || '',
                    '</div>'
                ].join(' ');

                daysStr += dayStr;
            });

            return daysStr;
        };

        const buildWeeks = (monthData) => {
            let weeksStr = '';

            monthData.forEach((weekData) => {
                const weekStr = [
                    '<div class="f-calendar__sheet--week">',
                    buildDays(weekData),
                    '</div>'
                ].join(' ');

                weeksStr += weekStr;
            });

            return weeksStr;
        };

        const title = `${ monthTitle }, ${ year }`;

        // Получаем данные для постройки месяца
        const monthData = _getDataForMonth.call(this, year, month);

        // Добавляем к году
        yearStr += [
            `<div class="f-calendar__sheet--month" month="${ month }" year="${ year || '' }">`,
                '<div class="f-calendar__sheet--month-header">',
                    `<div class="f-calendar__sheet--month-title">${ title }</div>`,
                    '<div class="f-calendar__sheet--month-hr"></div>',
                '</div>',
                buildWeeks(monthData),
            '</div>'
        ].join(' ');
    });

    yearStr += '</div>';

    return yearStr;
}

function _getMonths(year) {
    const config = this.config.get();
    const months = config.locale.month;
    const result = [...months];

    if (config.lowerLimit.year === year) {
        months.forEach((month, index) => {
            if (index < config.lowerLimit.month) {
                result[index] = '';
            }
        });
    }

    if (config.upperLimit.year === year) {
        months.forEach((month, index) => {
            if (index > config.upperLimit.month) {
                result[index] = '';
            }
        });
    }

    return result;
}

// Собираем список дней
function _getDataForMonth(year, month) {
    const { type, lowerLimit, upperLimit, workDays, workTime, dateFormat } = this.config.get();

    const daysInMonth = [];

    const lowerLimitMonth = lowerLimit.year === year && lowerLimit.month === month;
    const upperLimitMonth = upperLimit.year === year && upperLimit.month === month;

    const currentDay = this.root.helper.getCurrentDay();

    // Собираем первые дни недели предидущего месяца
    /* eslint no-loops/no-loops: 0 */
    let startDate = new Date(year, month);
    while (startDate.getDay() !== dateFormat.firstDay) {
        startDate.setDate(startDate.getDate() - 1);

        daysInMonth.unshift({
            day: startDate.getDay(),
            stub: true
        });
    }

    // Собираем дни текущего месяца
    startDate = new Date(year, month);

    while (startDate.getMonth() === month) {
        const day = {
            date: startDate.getDate(),
            month: startDate.getMonth(),
            year: startDate.getFullYear(),
            day: startDate.getDay()
        };

        const isCurrentDay = currentDay.year === day.year && currentDay.month === day.month && currentDay.date === day.date;

        // День за пределами доступных дат
        day.disabled = (
            (lowerLimitMonth && day.date < lowerLimit.date) ||
            (upperLimitMonth && day.date > upperLimit.date) ||
            (workDays && !workDays.includes(day.day))
        );

        // Если это сегодняшний день, для даты и времени проверяем так же диапазон рабочих часов
        if (type === 'datetime' && !day.disabled && isCurrentDay) {
            const lowerLimitDate = (lowerLimit.year === currentDay.year) && (lowerLimit.month === currentDay.month) && (currentDay.date === lowerLimit.date);

            // Все доступные часы для выбора уже прошли
            day.disabled = lowerLimitDate && ((currentDay.hour > workTime.finish.hour) || ((currentDay.hour === workTime.finish.hour) && (currentDay.minute >= workTime.finish.minute)));
        }

        daysInMonth.push(day);

        startDate.setDate(startDate.getDate() + 1);
    }

    // Собираем последнии дни недели следующего месяца
    while (startDate.getDay() !== dateFormat.firstDay) {
        daysInMonth.push({
            day: startDate.getDay(),
            stub: true
        });

        startDate.setDate(startDate.getDate() + 1);
    }

    // Разбиваем месяц на недели
    const monthForRender = [];

    daysInMonth.forEach((day) => {
        // Если текущий день равен дню старта недели, то создаем новую неделю
        if (day.day === dateFormat.firstDay) {
            monthForRender.push([]);
        }

        monthForRender[monthForRender.length - 1].push(day);
    });

    return monthForRender;
}
